import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Select } from '@rmwc/select';
import Scrollbar from "react-scrollbars-custom";
import { connect } from "react-redux";



class DoorWindowTextTop extends Component {
  render() {
 
    

    return (

             <div className="section-seprator">

                             <div className="section-title-wrapper">
                                 <h5 className="section-title mb-0">Instructions</h5>
                              </div>

                            <div className="price-row door-window-instruction">
                               <aside className="price-row-left">
                                <div className="col-md-12">
                                <div className="dw-ins-row">
                                <aside className="dw-ins-left">
                                <div className="dw-add-icon-var">
                                  <span className="icon-plus mr-1 icon"></span><span className="text">Add</span>
                                </div>                             
                                  
                                </aside>
                                <aside className="dw-ins-right">
                                    <p className="text-panelprimary f-12 barlow-semibold">Add items using the buttons below. Then, move the mouse to place them on the building. </p>
                                </aside>
                                </div>

                                   <div className="dw-ins-row">
                                <aside className="dw-ins-left">
                                <div className="dw-edit-icon-var">
                                  <span className="icon-content icon"></span><span className="text">Edit</span>
                                </div>                             
                                  
                                </aside>
                                <aside className="dw-ins-right">
                                    <p className="text-panelprimary f-12 barlow-semibold mb-0">Select the Component >> Click on the EDIT icon to update the style, size, or features of selected component. </p>
                                </aside>

                                </div>
                                </div>

                      


                               </aside>
                             </div>
                           </div>



      );
  }
}
const mapStoreToProps = (state) => {
  return state.reducer
  }
  
  
  export default connect(
  mapStoreToProps,
  )(DoorWindowTextTop);
